import React from 'react'
import cn from 'classnames'
import styles from 'components/shared/icons/icons.module.scss'
import { Speech } from 'lucide-react'

interface PeopleIconProps {
    contextStyles?: string
    selectedStyles?: string
    size?: number
}

export default function PeopleIcon({ contextStyles, selectedStyles, size }: PeopleIconProps) {
    return (
        <div className={cn(styles.iconComp, styles.fontIconComp, contextStyles, selectedStyles)}>
            <Speech size={size || 20} />
        </div>
    )
}
